export const MIN_REWARD_AMOUNT = 0.005;
//# sourceMappingURL=rewards.js.map